import { Button, Heading, Icon, Input, Select, Stack, StackDivider, Table, TableContainer, Tbody, Td, Text, Th, Thead, Tr, useToast } from "@chakra-ui/react";
import { useEffect, useState } from "react";
import { FaCheck } from "react-icons/fa";
import { MdAddBusiness } from "react-icons/md";

import { useSelector } from "react-redux";
import { BusinessModalForm } from "../../components/Modals/BusinessModal";
import APIDropdown from "../../components/Select/APIDropdown";
import { POST } from "../../utils/ApiRequestProvider";
import { RefreshBusinesses } from "../../utils/ReduxUtils";

export default function AddBusiness() {
    const toast = useToast();
    const businesses = useSelector((state: any) => state.businesses.value);

    useEffect(() => {
        console.log(businesses)
    }, [businesses])
    const [loading, setLoading] = useState(false);
    const [states, setStates] = useState<Array<any>>([]);

    const [form, setForm] = useState<BusinessModalForm>({
        businessName: '',
        businessShortName: '',
        documentInbox: '',
        businessType: '',
        organizationType: '',
        contactNumber: '',
        countryId: 0,
        currencyId: 0,
        stateId: 0,
        isOrganization: false
    });

    async function Save() {
        try {
            setLoading(true);

            const response = await POST('/api/business/create', form);
            toast({
                status: response.status,
                title: response.message,
                isClosable: false,
                duration: 1000,
                position: 'top-right'
            });

            setLoading(false);

            if (response.status === 'success') {
                RefreshBusinesses();
                setForm({
                    ...form,
                    businessName: '',
                    businessShortName: '',
                    documentInbox: '',
                    contactNumber: ''
                });
            }
        } catch (err) {
            toast({
                title: 'Something Went Wrong!',
                description: 'An unexpected error occured while proceeding your request!',
                status: 'error',
                isClosable: false,
                duration: 1000,
                position: 'top-right'
            });
        }
    }

    return (
        <Stack w={'full'} justify={"center"} align={"center"} spacing={6}>
            <Stack
                direction={{ base: 'column', md: 'column', lg: 'column', xl: 'row' }}
                justify={'space-between'}
                boxShadow={'base'}
                rounded={'xl'}
                w={'98%'}
                p={4}
                spacing={{ base: 6, md: 6, lg: 6, xl: 0 }}
                align={'center'}
            >
                <Stack
                    align={'flex-start'}
                    justify={'start'}
                    spacing={4}
                >
                    <Stack direction={'row'}>
                        <Icon
                            as={MdAddBusiness}
                            fontSize={'5xl'}
                            color={'primary.400'}
                        />
                        <Stack spacing={1}>
                            <Heading fontSize={'xl'}>Add New Business</Heading>
                            <Text fontSize={'sm'}>Add new Businesses from here</Text>
                        </Stack>
                    </Stack>
                </Stack>
            </Stack>
            <Stack boxShadow={'base'} rounded={'xl'} w={'98%'} p={4} spacing={4} divider={<StackDivider />}>
                <Stack
                    w={'full'}
                    spacing={4}
                    direction={'row'}
                >
                    <Stack spacing={4} w={'full'}>
                        <Input
                            w={'full'}
                            type={'text'}
                            size={'md'}
                            placeholder={'Business / Person Name'}
                            value={form.businessName}
                            onChange={(e: any) => setForm({ ...form, businessName: e.target.value })}
                        />
                        <Input
                            w={'full'}
                            type={'text'}
                            size={'md'}
                            placeholder={'Business / Short Name'}
                            value={form.businessShortName}
                            onChange={(e: any) => {
                                setForm({
                                    ...form,
                                    businessShortName: e.target.value.replace(/[^a-zA-Z ]/g, ""),
                                    documentInbox: e.target.value.replace(/[^a-zA-Z ]/g, '').replace(/ /g, "-").toLowerCase() + `@app.entry-bot.com`
                                })
                            }}
                        />
                        <Select
                            w={'full'}
                            placeholder='Business Type'
                            value={form.businessType}
                            onChange={(e: any) =>
                                setForm({ ...form, businessType: e.target.value })
                            }
                        >
                            <option value={'Accountant/Bookkeeper/TaxAdvisor'}>Accountant/Bookkeeper/TaxAdvisor</option>
                            <option value={'Beauty Salons and Spas'}>Beauty Salons and Spas</option>
                            <option value={'Building and Construction'}>Building and Construction</option>
                            <option value={'Business Consulting'}>Business Consulting</option>
                            <option value={'Cleaning Services'}>Cleaning Services</option>
                            <option value={'E-Commerce'}>E-Commerce</option>
                            <option value={'Engineering Firms and Contractors'}>Engineering Firms and Contractors</option>
                            <option value={'Fashion Industry'}>Fashion Industry</option>
                            <option value={'Food and Beverages'}>Food and Beverages</option>
                            <option value={'Hospitality and Tourism'}>Hospitality and Tourism</option>
                            <option value={'IT and Web Services'}>IT and Web Services</option>
                            <option value={'Law Firm'}>Law Firm</option>
                            <option value={'Leisure and Fitness'}>Leisure and Fitness</option>
                            <option value={'Marketing and Social Media Marketing'}>Marketing and Social Media Marketing</option>
                            <option value={'Other'}>Other</option>
                            <option value={'Petrol Retailers'}>Petrol Retailers</option>
                            <option value={'Recruitment Firms'}>Recruitment Firms</option>
                            <option value={'Restaurants and Cafes'}>Restaurants and Cafes</option>
                            <option value={'Travel Industry'}>Travel Industry</option>
                            <option value={'Warehousing and Logistics'}>Warehousing and Logistics</option>
                        </Select>
                        <APIDropdown
                            w={'full'}
                            placeholder={'Country Name'}
                            fetchurl={'/api/country'}
                            itemselect={(item) => {
                                setForm({ ...form, countryId: item.id })
                                setStates(item.states);
                            }}
                            valuekey={'id'}
                            textkey={'name'}
                        />
                        <Select
                            w={'full'}
                            placeholder='City / State'
                            value={form.stateId}
                            onChange={(e: any) =>
                                setForm({ ...form, stateId: parseInt(e.target.value) })
                            }
                        >
                            {
                                states.map(s => (
                                    <option value={s.id}>{s.name}</option>
                                ))
                            }
                        </Select>
                    </Stack>
                    <Stack spacing={4} w={'full'}>
                        <Select
                            w={'full'}
                            placeholder='Organization Type'
                            value={form.organizationType}
                            onChange={(e: any) =>
                                setForm({ ...form, organizationType: e.target.value })
                            }
                        >
                            <option value={'Limited Company'}>Limited Company</option>
                            <option value={'Not for Profit'}>Not for Profit</option>
                            <option value={'Partnership'}>Partnership</option>
                            <option value={'Person'}>Person</option>
                            <option value={'Sole Traders'}>Sole Traders</option>
                            <option value={'Other'}>Other</option>
                        </Select>
                        <Input
                            w={'full'}
                            type={'text'}
                            size={'md'}
                            value={form.documentInbox}
                            disabled
                            placeholder={'Document Inbox'}
                        />
                        <Input
                            w={'full'}
                            type={'text'}
                            size={'md'}
                            value={form.contactNumber}
                            onChange={(e: any) => setForm({ ...form, contactNumber: e.target.value })}
                            placeholder={'Contact Number'} />
                        <APIDropdown
                            w={'full'}
                            placeholder={'Base Currency'}
                            fetchurl={'/api/currency'}
                            itemselect={(item) => setForm({ ...form, currencyId: item.id })}
                            valuekey={'id'}
                            textkey={'currencyName'}
                        />
                    </Stack>
                </Stack>
                <Button
                    w={'full'}
                    onClick={Save}
                    leftIcon={<FaCheck />}
                    colorScheme={'primary'}
                    isLoading={loading}
                >
                    Save
                </Button>
            </Stack>

            <Stack boxShadow={'base'} rounded={'xl'} w={'98%'} p={4} spacing={4}>
                <TableContainer>
                    <Table size='sm'>
                        <Thead position={'sticky'} top={'0%'} h={'50px'} bg={'primary.400'} alignItems={'flex-start'}>
                            <Tr>
                                <Th
                                    color={'white'}
                                    isNumeric
                                >
                                    ID
                                </Th>
                                <Th
                                    color={'white'}
                                >
                                    Business Name
                                </Th>
                                <Th
                                    color={'white'}
                                >
                                    Organization Type
                                </Th>
                                <Th
                                    color={'white'}
                                >
                                    Short Name
                                </Th>
                                <Th
                                    color={'white'}
                                >
                                    Document Inbox
                                </Th>
                                <Th
                                    color={'white'}
                                >
                                    Industry
                                </Th>
                                <Th
                                    color={'white'}
                                >
                                    Contact Number
                                </Th>
                                <Th
                                    color={'white'}
                                >
                                    Country
                                </Th>
                                <Th
                                    color={'white'}
                                >
                                    City / State
                                </Th>
                                <Th
                                    color={'white'}
                                >
                                    Base Currency
                                </Th>
                            </Tr>
                        </Thead>
                        <Tbody>
                            {
                                businesses && businesses.map((item: any) => (
                                    <Tr>
                                        <Td isNumeric>{item.id}</Td>
                                        <Td>{item.businessName}</Td>
                                        <Td>{item.organizationType}</Td>
                                        <Td>{item.businessShortName}</Td>
                                        <Td>{item.documentInbox}</Td>
                                        <Td>{item.businessType}</Td>
                                        <Td>{item.contactNumber}</Td>
                                        <Td>{item.country?.name ?? ''}</Td>
                                        <Td>{item.state?.name ?? ''}</Td>
                                        <Td>{item.baseCurrency?.currencyCode ?? ''}</Td>
                                    </Tr>
                                ))
                            }
                        </Tbody>
                    </Table>
                </TableContainer>
                {/* <Stack
                    direction={'row'}
                    justify={"space-between"}
                    align={'center'}
                >
                    <Text>Showing 5 of 10 results</Text>
                    <Stack direction={'row'} spacing={4}>
                        <Select placeholder="Select Rows Per Page">
                            <option selected>5 Per Page</option>
                            <option>10 Per Page</option>
                            <option>25 Per Page</option>
                            <option>50 Per Page</option>
                        </Select>
                        <Stack direction={'row'}>
                            <IconButton
                                aria-label="Previous"
                                icon={<FaArrowLeft />}
                                rounded={'full'}
                            />
                            <IconButton
                                aria-label="Previous"
                                icon={<FaArrowRight />}
                                rounded={'full'}
                            />
                        </Stack>
                    </Stack>
                </Stack> */}
            </Stack>
        </Stack >
    )
}